import { commitMutation } from 'react-relay'
import graphql from 'babel-plugin-relay/macro'
import { ConnectionHandler } from 'relay-runtime'

import _ from 'lodash'

import environment from './Environment'

const commitMutationAsPromise = (environment, options) => {
  return new Promise((resolve, reject) => {
    commitMutation(environment, {
      ...options,
      onError: err => reject(err),
      onCompleted: (rsp, errors) => {
        if (errors) {
          console.error('Failed to execute GraphQL mutation', errors.map(e => e.message).join(', '))
          return reject(errors)
        }

        return resolve(rsp)
      }
    })
  })
}

const authenticateWithParticipantShortId = (shortId, name, phone, email) => {
  return commitMutationAsPromise(
    environment, {
      mutation: graphql`
        mutation apiAuthenticateWithParticipantShortIdMutation($shortId: String!, $name: String, $phone: String, $email: String) {
          authenticateWithParticipantShortId(shortId: $shortId, name: $name, phone: $phone, email: $email) {
            jwt
          }
        }
      `,
      variables: {
        shortId,
        name,
        phone,
        email
      }
    })
}

const createPlainTextMessage = ({ conversationId, userId, body }) => {
  return commitMutationAsPromise(
    environment, {
      mutation: graphql`
        mutation apiCreatePlainTextMessageMutation ($conversationId: Uuid!, $userId: Uuid!, $body: String!) {
          createPlainTextMessage(conversationId: $conversationId, userId: $userId, body: $body) {
            message {
              id
              createdAt
              bodyExcerpt
              sender
              conversation: conversationByConversationId {
                id
              }
              user: userByUserId {
                id
                firstName
                lastName
                pictureUrl
              }
              ...MessageRow_message
            }
          }
        }
      `,
      variables: {
        conversationId,
        userId,
        body
      },
      updater: store => {
        const conversation = store.get(conversationId)
        const messagesConnection = ConnectionHandler.getConnection(conversation, 'Conversation_messages')
        if (messagesConnection) {
          const payload = store.getRootField('createPlainTextMessage')
          const node = payload.getLinkedRecord('message')
          const newEdge = ConnectionHandler.createEdge(
            store,
            messagesConnection,
            node,
            'MessagesEdge'
          )
          ConnectionHandler.insertEdgeBefore(messagesConnection, newEdge)
        }
      }
    }
  )
}

const markMessageAsReadWithFetch = ({ userId, messageId, conversationId }) => {
  return commitMutationAsPromise(
    environment, {
      mutation: graphql`
        mutation apiMarkMessagesAsReadWithFetchMutation($messageId: Uuid!, $associationId: Uuid, $associationType: ParticipantAssociationType) {
          markMessageAsRead(messageId: $messageId, associationId: $associationId, associationType: $associationType) {
            id
            createdAt
            sender
            conversation: conversationByConversationId {
              id
            }
            ...MessageRow_message
          }
        }
      `,
      variables: {
        messageId,
        associationId: userId,
        associationType: 'USER'
      },
      updater: store => {
        const node = store.get(messageId)
        if (node && userId) {
          const readBy = node.getValue('readBy')
          node.setValue(_.union(readBy || [], [userId]), 'readBy')
        }

        const conversation = store.get(conversationId)
        if (conversation) {
          const messagesConnection = ConnectionHandler.getConnection(conversation, 'Conversation_messages')
          if (messagesConnection) {
            const node = store.getRootField('markMessageAsRead')
            const newEdge = ConnectionHandler.createEdge(
              store,
              messagesConnection,
              node,
              'MessagesEdge'
            )
            ConnectionHandler.insertEdgeBefore(messagesConnection, newEdge)
          }
        } else {
          console.error(`failed to find conversation ${conversationId} in store`)
        }
      }
    }
  )
}

export {
  authenticateWithParticipantShortId,
  createPlainTextMessage,
  markMessageAsReadWithFetch
}
